import { render } from "./channel-change-warning.vue?vue&type=template&id=1fec3614&lang=pug"
import script from "./channel-change-warning.vue?vue&type=script&lang=js"
export * from "./channel-change-warning.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__